import { RouteObject } from "react-router-dom";

export const SECURITY_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { Security } = await import("./Security");
      return {
        element: <Security />,
      };
    },
  },
  {
    path: "two-factor-authentication",
    async lazy() {
      return { element: <div>Two-factor authentication</div> };
    },
  },
  {
    path: "password",
    async lazy() {
      const { PasswordChange } = await import("./passwordChange");
      return { element: <PasswordChange /> };
    },
  },
  {
    path: "authenticator",
    async lazy() {
      const { AuthenticatorVerification } = await import("./authenticatorVerification");
      return { element: <AuthenticatorVerification /> };
    },
  },
  {
    path: "codes",
    async lazy() {
      const { RecoveryCodes } = await import("./recoveryCodes");
      return { element: <RecoveryCodes /> };
    },
  },
  {
    path: "phone",
    async lazy() {
      const { PhoneVerification } = await import("./phoneVerification");
      return { element: <PhoneVerification /> };
    },
  },
  {
    path: "email",
    async lazy() {
      const { EmailVerification } = await import("./emailVerification");
      return { element: <EmailVerification /> };
    },
  },
];
